import React from 'react';
import styled from 'styled-components';

import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';

const DateDivider: React.FC<{ dateString: string }> = props => {
    const date = new Date(props.dateString);
    return (
        <DividerContainer>
            <Typography
                variant="subtitle2"
                fontWeight={700}
                fontSize="11px"
                lineHeight="15px"
            >
                {date.toLocaleDateString(undefined, {
                    month: 'long',
                    year: 'numeric',
                })}
            </Typography>
        </DividerContainer>
    );
};

const DividerContainer = styled(ListItem)`
    position: sticky;
    top: 4px;
    margin-top: 4px;
    margin-bottom: 2px;
    z-index: 1;
    color: #697d90;
    border-radius: 4px;
    padding: 8px 12px;
    text-transform: uppercase;
    background: #f0f4f7;
    font-style: normal;
    font-weight: 700;
    letter-spacing: 0.5px;
    &:before {
        content: '';
        width: 100%;
        position: absolute;
        top: -4px;
        height: 4px;
        background: white;
        left: 0;
    }
`;

export default DateDivider;
